import '@stackflow/plugin-basic-ui/index.css';
import AppToaster from '@components/AppToaster';
import BottomSheets from '@components/BottomSheets';
import CheckingService from '@components/CheckingService';
import ErrorBoundary from '@components/ErrorBoundary';
import GlobalModal from '@components/GlobalModal';
import GlobalLoader from '@components/Loading/GlobalLoader';
import AppProvider from '@providers/AppProvider';
import { Stack } from '@router/stackflow';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import '@locales/i18n';
import '@styles/index.scss';
import 'react-loading-skeleton/dist/skeleton.css';
// @ts-ignore
import 'swiper/css';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Seoul');

function App() {
    return (
        <AppProvider>
            <ErrorBoundary>
                <Stack/>
                <AppToaster/>
                <GlobalLoader/>
                <GlobalModal/>
                <BottomSheets/>
                <CheckingService/>
            </ErrorBoundary>
        </AppProvider>
    );
}

export default App;
